import Stage from '@/components/user/dashboard/pages/club-standard/stage/stage.vue';
import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Table, TableColumn } from 'element-ui';
import MedalDecider from '@/components/shared/medals/club/decider/decider.vue';

export default {
    name: 'ClubStandardTableList',
    props: {
        data: Array,
        isProcessing: Boolean,
        from: Number,
        to: Number,
        total: Number,
        page: Number,
        perPage: Number,
        currentClubId: Number,
        currentStandardType: [Number, String],
        currentBlockOrderNumber: [Number, String]
    },
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        'stage': Stage,
        'medal-decider': MedalDecider
    },
    data() {
        return {
        }
    },
    computed: {
        tabIndex() {
            if (this.$route.query && this.$route.query.tabIndex > 1) {
                return this.$route.query.tabIndex;
            }
            return false;
        }
    },
    methods: {
        showError(message) {
            if (!message) {
                message = 'Something went wrong. Incorrect request!';
            }
            this.$notify({
                message: message,
                type: 'danger',
                timeout: 5000
            });
        },
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 1000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        init() {
            this.load();
        },
        load() {

        },
        rowClick(data, orderNumber) {
            this.$emit("update:currentClubId", data.id);
            this.$emit("update:currentStandardType", data.applicationStandardType);
            this.$emit("update:currentClubName", data.clubName);
            this.$emit("update:currentBlockOrderNumber", orderNumber);
        }
    },
    mounted() {
        this.init();
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/club-standards/table/table.js